import { MANAGE_USER, ORGANIZATION } from "../actions/utilities";

const INITIAL_STATE = {
  getManageUserLoading: false,
  getManageUserSuccess: false,
  getManageUserFailure: false,
  getManageUserError: null,
  manageUserList: [],

  changeUserStatusLoading: false,
  changeUserStatusSuccess: false,
  changeUserStatusFailure: false,
  changeUserStatusError: null,
  userStatus: [],

  activeOrganization: [],
};
export const manageUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MANAGE_USER.GET_MANAGE_USER_REQUEST:
      return {
        ...state,
        getManageUserLoading: true,
        getManageUserSuccess: false,
        getManageUserFailure: false,
        getManageUserError: null,
      };
    case MANAGE_USER.GET_MANAGE_USER_SUCCESS:
      let list = [];
      if (action?.payload?.length > 0) {
        list = action.payload;
      }
      return {
        ...state,
        getManageUserLoading: false,
        getManageUserSuccess: true,
        getManageUserFailure: false,
        getManageUserError: null,
        manageUserList: list,
      };
    case MANAGE_USER.GET_MANAGE_USER_FAILURE:
      return {
        ...state,
        getManageUserLoading: false,
        getManageUserSuccess: false,
        getManageUserFailure: true,
        getManageUserError: action.payload,
        manageUserList: null,
      };
    case MANAGE_USER.ADD_MANAGE_USER_REQUEST:
      return {
        ...state,
        getManageUserLoading: true,
        getManageUserSuccess: false,
        getManageUserFailure: false,
        getManageUserError: null,
      };
    case MANAGE_USER.ADD_MANAGE_USER_SUCCESS:
      let addManageUser = state.manageUserList;
      addManageUser.unshift(action.payload);

      return {
        ...state,
        getManageUserLoading: false,
        getManageUserSuccess: true,
        getManageUserFailure: false,
        getManageUserError: null,
        manageUserList: addManageUser,
      };
    case MANAGE_USER.ADD_MANAGE_USER_FAILURE:
      return {
        ...state,
        getManageUserLoading: false,
        getManageUserSuccess: false,
        getManageUserFailure: true,
        getManageUserError: action.payload,
      };
    case MANAGE_USER.EDIT_MANAGE_USER_REQUEST:
      return {
        ...state,
        getManageUserLoading: true,
        getManageUserSuccess: false,
        getManageUserFailure: false,
        getManageUserError: null,
      };
    case MANAGE_USER.EDIT_MANAGE_USER_SUCCESS:
      let editManageUser = state.manageUserList;
      for (var i = 0; i < editManageUser.length; i++) {
        if (editManageUser[i].userId === action.payload.userId) {
          editManageUser[i] = action.payload;
        }
      }
      return {
        ...state,
        getManageUserLoading: false,
        getManageUserSuccess: true,
        getManageUserFailure: false,
        getManageUserError: null,
        manageUserList: editManageUser,
      };
    case MANAGE_USER.EDIT_MANAGE_USER_FAILURE:
      return {
        ...state,
        getManageUserLoading: false,
        getManageUserSuccess: false,
        getManageUserFailure: true,
        getManageUserError: action.payload,
      };
    case MANAGE_USER.DELETE_MANAGE_USER_REQUEST:
      return {
        ...state,
        getManageUserLoading: true,
        getManageUserSuccess: false,
        getManageUserFailure: false,
        getManageUserError: null,
      };
    case MANAGE_USER.DELETE_MANAGE_USER_SUCCESS:
      let userDelete = state.manageUserList;
      let payload = userDelete.filter((item) => item.userId != action.payload);
      return {
        ...state,
        getManageUserLoading: false,
        getManageUserSuccess: true,
        getManageUserFailure: false,
        getManageUserError: null,
        manageUserList: payload,
      };
    case MANAGE_USER.DELETE_MANAGE_USER_FAILURE:
      return {
        ...state,
        getManageUserLoading: false,
        getManageUserSuccess: false,
        getManageUserFailure: true,
        getManageUserError: action.payload,
      };

    case MANAGE_USER.CHANGE_USER_STATUS_REQUEST:
      return {
        ...state,
        changeUserStatusLoading: true,
        changeUserStatusSuccess: false,
        changeUserStatusFailure: false,
        changeUserStatusError: null,
      };
    case MANAGE_USER.CHANGE_USER_STATUS_SUCCESS:
      return {
        ...state,
        changeUserStatusLoading: false,
        changeUserStatusSuccess: true,
        changeUserStatusFailure: false,
        changeUserStatusError: null,
        userStatus: action.payload,
      };
    case MANAGE_USER.CHANGE_USER_STATUS_FAILURE:
      return {
        ...state,
        changeUserStatusLoading: false,
        changeUserStatusSuccess: false,
        changeUserStatusFailure: true,
        changeUserStatusError: action.payload,
      };

    default:
      return state;
  }
};
